import React from "react";

import styles from "./PlaceholderModal.module.scss";

import { ReactComponent as CrossdIcon } from "../../assets/cross.svg";
import { useModal } from "../../stores/useModel";

type Props = {
  children: React.ReactNode;
};

function PlaceholderModal({ children }: Props) {
  const setShowModal = useModal(state => state.setShowModal);

  return (
    <div className={styles.container}>
      <div
        className={styles.header}
        onClick={() => {
          setShowModal(false);
        }}
      >
        <CrossdIcon />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

export default React.memo(PlaceholderModal);
